module.exports = __webpack_public_path__ + "img/icon-sent-access.db427ce4.svg";